import React from "react";

export const Divider = (props: { className?: string }): React.ReactElement => {
    return <hr className={`divider ${props.className}`} />;
};
